"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = minorScale;

/**
 * Helper function to conform to 4 (px) minor scale.
 * @param {number} x — unitless number
 * @return {number} - unitless number
 * @example
 * minorScale(3) => 3*4 = 12
 * minorScale(1) => 1*4 = 4
 */
function minorScale(x) {
  if (!Number.isInteger(x)) {
    throw new TypeError("minorScale only accepts integers as input, instead ".concat(x, " was passed."));
  }

  return x * 4;
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9zY2FsZXMvc3JjL21pbm9yU2NhbGUuanMiXSwibmFtZXMiOlsibWlub3JTY2FsZSIsIngiLCJOdW1iZXIiLCJpc0ludGVnZXIiLCJUeXBlRXJyb3IiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7Ozs7Ozs7QUFRZSxTQUFTQSxVQUFULENBQW9CQyxDQUFwQixFQUF1QjtBQUNwQyxNQUFJLENBQUNDLE1BQU0sQ0FBQ0MsU0FBUCxDQUFpQkYsQ0FBakIsQ0FBTCxFQUEwQjtBQUN4QixVQUFNLElBQUlHLFNBQUosOERBQ2tESCxDQURsRCxrQkFBTjtBQUdEOztBQUVELFNBQU9BLENBQUMsR0FBRyxDQUFYO0FBQ0QiLCJzb3VyY2VzQ29udGVudCI6WyIvKipcbiAqIEhlbHBlciBmdW5jdGlvbiB0byBjb25mb3JtIHRvIDQgKHB4KSBtaW5vciBzY2FsZS5cbiAqIEBwYXJhbSB7bnVtYmVyfSB4IOKAlCB1bml0bGVzcyBudW1iZXJcbiAqIEByZXR1cm4ge251bWJlcn0gLSB1bml0bGVzcyBudW1iZXJcbiAqIEBleGFtcGxlXG4gKiBtaW5vclNjYWxlKDMpID0+IDMqNCA9IDEyXG4gKiBtaW5vclNjYWxlKDEpID0+IDEqNCA9IDRcbiAqL1xuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gbWlub3JTY2FsZSh4KSB7XG4gIGlmICghTnVtYmVyLmlzSW50ZWdlcih4KSkge1xuICAgIHRocm93IG5ldyBUeXBlRXJyb3IoXG4gICAgICBgbWlub3JTY2FsZSBvbmx5IGFjY2VwdHMgaW50ZWdlcnMgYXMgaW5wdXQsIGluc3RlYWQgJHt4fSB3YXMgcGFzc2VkLmBcbiAgICApXG4gIH1cblxuICByZXR1cm4geCAqIDRcbn1cbiJdfQ==


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/scales/src/minorScale.js
// module id = 181
// module chunks = 0